<div class="ui2-user-search">
  <span
    class="ui2-dropdown-container"
    [ui2Tooltip]="tooltipTranslation?.translationKey | translate : tooltipTranslation?.interpolation"
    [mode]="tooltipMode"
  >
    <ng-select
      #selectMultiple
      [ngClass]="{
        disabled: isDisabled
      }"
      class="ui2-dropdown"
      [items]="users"
      [placeholder]="placeholder | translate"
      [(ngModel)]="selectedUsers"
      [multiple]="isMultiSelect"
      [closeOnSelect]="closeOnSelect"
      [searchFn]="searchModel"
      (search)="search($event)"
      [hideSelected]="hideSelected"
      [clearable]="false"
      bindLabel="userUri"
      [maxSelectedItems]="maxCardinality"
      [disabled]="isDisabled"
      (ngModelChange)="onValueChange($event)"
      (scrollToEnd)="scrollToEnd.emit()"
      (open)="onDropdownOpen.emit()"
      (close)="onDropdownClose.emit()"
    >
      <ng-template ng-header-tmp>
        <ui2-dropdown-search-bar [select]="selectMultiple"></ui2-dropdown-search-bar>
      </ng-template>

      <!-- blank label template is used to remove default label design after item selection -->
      <ng-template ng-label-tmp> </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index">
        <ui2-user-search-chip
          [user]="item"
          [chipsLabel]="item?.labelKey && chipsLabelMapper?.[item.labelKey]"
          [hideCloseIcon]="true"
          [isDisabled]="item.disabled"
        ></ui2-user-search-chip>
      </ng-template>
    </ng-select>
  </span>

  <div class="mt-3 selected-users" [ngStyle]="selectedUsersStyle">
    @if(isLoading){
    <div class="loader-container justify-center">
      <ui-loader class="loader-ng-select"></ui-loader>
    </div>
    } @else if(isMultiSelect) {

    <ng-container *ngFor="let user of selectedUsers">
      <ui2-user-search-chip
        class="mb-3 has-border bold-title"
        [user]="user"
        [hideCloseIcon]="disabled || isBelowMinSelectionThreshold"
        (closeClicked)="clearSelectedUser($event)"
      />
    </ng-container>

    } @else if(selectedUsers) {

    <ui2-user-search-chip
      class="mb-3 has-border bold-title"
      [user]="selectedUsers"
      [hideCloseIcon]="disabled || isBelowMinSelectionThreshold"
      (closeClicked)="clearSelectedUser($event)"
    />

    }
  </div>
</div>
